import IMMIGRATION_IMG from "../../assets/immigration_hero_img.png"

import IMM_STAT_1 from "../../assets/imm-Stat-1.png"
import IMM_STAT_2 from "../../assets/imm-Stat-2.png"

import IMM_SHIELD_RED from "../../assets/Shield Done - Iconly Pro.png"
import IMM_RED_PEN from "../../assets/pen_red.png"
import IMM_RED_MEDAL from "../../assets/Medal - Iconly Pro.png"
import IMM_RED_LANG from "../../assets/Vector.png"

import SEARCH_IMG from "../../assets/Search 1 - Iconly Pro.png"

import IMM_ASSESSMENT_1 from "../../assets/imm-asesment.png"
import IMM_ASSESSMENT_2 from "../../assets/imm-asesment-1.png"
import IMM_ASSESSMENT_3 from "../../assets/imm-asesment-2.png"
import IMM_ASSESSMENT_4 from "../../assets/imm-asesment-3.png"
import IMM_ASSESSMENT_5 from "../../assets/imm-asesment-4.png"

import IMM_SEC4_MOBILEIMG from "../../assets/imm-sec4-mobileImg.png"

import IMM_SEC6_1 from "../../assets/imm-sec6_1.png"
import IMM_SEC6_2 from "../../assets/imm-sec6_2.png"
import IMM_SEC6_3 from "../../assets/imm-sec6_3.png"
import IMM_SEC6_4 from "../../assets/imm-sec6_4.png"

import IMM_SEC7_1 from "../../assets/imm-sec7_1.png"
import IMM_SEC7_2 from "../../assets/imm-sec7_2.png"
import IMM_SEC7_3 from "../../assets/imm-sec7_3.png"
import IMM_SEC7_4 from "../../assets/imm-sec7_4.png"
import IMM_SEC7_5 from "../../assets/imm-sec7_5.png"
import IMM_SEC7_6 from "../../assets/imm-sec7_6.png"


import IMM_SEC8_1 from "../../assets/imm-sec8_1.png"
import IMM_SEC8_2 from "../../assets/imm-sec8_2.png"
import IMM_SEC8_3 from "../../assets/imm-sec8_3.png"
import IMM_SEC8_4 from "../../assets/imm-sec8_4.png"

import IMM_SEC9_MOBILE from "../../assets/imm-sec9-img.png"
import IMM_SEC9_DESKTOP from "../../assets/imm-sec9-DesktopImg.png"
import IMM_SEC9_MOBILE_Bg from "../../assets/Ellipse 180.svg"
import IMM_SEC9_DESKTOP_Bg from "../../assets/imm-sec9-DesktopBgImg.png"

import IMM_SEC10_LEFTDIV from "../../assets/imm-sec10-left.png"
import IMM_SEC10_RIGHTDIV from "../../assets/imm-sec10-right.png"

import IMM_SEC11_IMG from "../../assets/imm-sec11_img.png"




export const IMAGES = {
    IMMIGRATION_IMG,
    IMM_STAT_1,
    IMM_STAT_2,
    IMM_SHIELD_RED,
    IMM_RED_LANG,
    IMM_RED_MEDAL,
    IMM_RED_PEN,
    SEARCH_IMG,
    IMM_ASSESSMENT_1,
    IMM_ASSESSMENT_2,
    IMM_ASSESSMENT_3,
    IMM_ASSESSMENT_4,
    IMM_ASSESSMENT_5,
    IMM_SEC4_MOBILEIMG,
    IMM_SEC6_1,
    IMM_SEC6_2,
    IMM_SEC6_3,
    IMM_SEC6_4,
    IMM_SEC7_1,
    IMM_SEC7_2,
    IMM_SEC7_3,
    IMM_SEC7_4,
    IMM_SEC7_5,
    IMM_SEC7_6,
    IMM_SEC8_1,
    IMM_SEC8_2,
    IMM_SEC8_3,
    IMM_SEC8_4,
    IMM_SEC9_MOBILE,
    IMM_SEC9_DESKTOP,
    IMM_SEC9_MOBILE_Bg,
    IMM_SEC10_LEFTDIV,
    IMM_SEC10_RIGHTDIV,
    IMM_SEC11_IMG,
}